import React from "react";

import { CrossRed, NotificationSuccess, NotificationInfo, CloseGreyIcon } from "../../assets/icons";
import { useNotification } from "./NotificationContext";

const TosterNotification: React.FC = () => {

    const { notifications, removeNotification } = useNotification();

    return (
        <section className="toast-notification-section">
            <div className="w-layout-blockcontainer container toast-notification w-container">
                <div className="toast-notification-wrapper">
                    <div className="toast-notification-list">

                        {notifications.map(notification => (

                            <div className={`toast-notification-div ${notification.type}`} key={notification.id}>
                                <div className="toast-notification-icon-div">
                                    <img src={notification.type === "success" ? NotificationSuccess : notification.type === "error" ? CrossRed : NotificationInfo} loading="lazy" alt="" className="toast-notification-icon"/>
                                </div>
                                <div className="toast-notification-info-block">
                                    <div className={`toast-notification-title ${notification.type}`}>{notification.title ?? (notification.type === "success" ? "Success" : notification.type === "error" ? "Error" : "Info")}</div>
                                    <div className="toast-notification-text">{notification.message}</div>
                                </div>
                                <div className="toast-notification-close-icon-div" onClick={() => removeNotification(notification.id)}>
                                    <img src={CloseGreyIcon} loading="lazy" alt="" className="icon-size-16 pointer" />
                                </div>
                            </div>
                        ))}

                        {/* <div className="toast-notification-div">
                            <div className="toast-notification-icon-div">
                                <img src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg" loading="lazy" alt="" />
                            </div>
                            <div className="toast-notification-info-block">
                                <div className="toast-notification-title">Success</div>
                                <div className="toast-notification-text">Success login in.</div>
                            </div>
                            <div className="toast-notification-close-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6919e1cea5b1e8f2ca17ae1a_close%20(3).png" loading="lazy" alt="" className="icon-size-16" />
                            </div>
                        </div>

                        <div className="toast-notification-div success">
                            <div className="toast-notification-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/69309e8f7e10fa2172b5123c_check-mark.png" loading="lazy" alt="" className="toast-notification-icon" />
                            </div>
                            <div className="toast-notification-info-block">
                                <div className="toast-notification-title success">Success</div>
                                <div className="toast-notification-text">Success login in.</div>
                            </div>
                            <div className="toast-notification-close-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6919e1cea5b1e8f2ca17ae1a_close%20(3).png" loading="lazy" alt="" className="icon-size-16 pointer" />
                            </div>
                        </div>

                        <div className="toast-notification-div error">
                            <div className="toast-notification-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/69309e8fa2c4cd78407a66e8_cross.png" loading="lazy" alt="" className="toast-notification-icon" />
                            </div>
                            <div className="toast-notification-info-block">
                                <div className="toast-notification-title error">Error</div>
                                <div className="toast-notification-text">Success login in.</div>
                            </div>
                            <div className="toast-notification-close-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6919e1cea5b1e8f2ca17ae1a_close%20(3).png" loading="lazy" alt="" className="icon-size-16 pointer" />
                            </div>
                        </div>

                        <div className="toast-notification-div info">
                            <div className="toast-notification-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/69309e8f67ec794659bcca23_information.png" loading="lazy" alt="" className="toast-notification-icon" />
                            </div>
                            <div className="toast-notification-info-block">
                                <div className="toast-notification-title info">Success</div>
                                <div className="toast-notification-text">Success login in.</div>
                            </div>
                            <div className="toast-notification-close-icon-div">
                                <img src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6919e1cea5b1e8f2ca17ae1a_close%20(3).png" loading="lazy" alt="" className="icon-size-16 pointer" />
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        </section>

    );

};

export default TosterNotification;